module.exports = __webpack_public_path__ + "img/topika.30518a3e.jpg";